import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { PdpSharedBlurbRareFind_item$key } from './__generated__/PdpSharedBlurbRareFind_item.graphql';

// components
import Sparkle from 'dibs-icons/exports/Sparkle';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';
import { PdpSharedPricingGuidanceCopy } from '../PdpSharedPricingGuidance/PdpSharedPricingGuidanceCopy';

// helpers
import { rareFindTitle } from '../messages/pdpBlurbMessages';

type Props = {
    item: PdpSharedBlurbRareFind_item$key;
};

export const PdpSharedBlurbRareFind: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedBlurbRareFind_item on Item {
                ...PdpSharedPricingGuidanceCopy_item
                pricingGuidance {
                    rareFind
                }
            }
        `,
        itemRef
    );

    if (!item?.pricingGuidance?.rareFind) {
        return null;
    }

    return (
        <PdpSharedBlurb
            IconComponent={Sparkle}
            title={rareFindTitle}
            detail={<PdpSharedPricingGuidanceCopy item={item} />}
        />
    );
};

export default PdpSharedBlurbRareFind;
